import {Authenticated} from './middleware'

export default [

  {
    name: 'user',
    path: '/',
    redirect: {name: 'user.list'},
    component: () => import ('../../views/cpanel/user/index'),
    meta: {
      title: 'Клиенты',
      back: 'cpanel.dashboard',
      middleware: Authenticated
    },
    children: [
      {
        name: 'user.list',
        path: '/',
        component: () => import ('../../views/cpanel/user/List'),
        meta: {
          title: 'Клиенты',
          back: 'cpanel.dashboard',
          middleware: Authenticated
        },
      },
      {
        name: 'user.item',
        path: ':id?',
        component: () => import ('../../views/cpanel/user/Item'),
        meta: {
          title: 'Профиль клиента',
          back: 'visit.list',
          middleware: Authenticated,
          permission: 'can.manage.users'
        }
      }
    ]
  },


];
